// extracted by mini-css-extract-plugin
export default {"header":"Header_header__bX2Eb","logo":"Header_logo__b3OoK","active":"Header_active__xAy0g"};